import styled from 'styled-components/macro';
import { defaultContainer } from '../../../../styles/utils';

export const SignupsDiv = styled.div`
  ${defaultContainer}
  display: flex;
  padding-top: 2rem;
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
  }
`;

export const SignupStatDiv = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 1rem;
  border-right: ${props => props.theme.defaultBorder};
  &:nth-of-type(even) {
    border-right: none;
  }
  @media screen and (min-width: 768px) {
    width: 25%;
    &:nth-of-type(2) {
      border-right: ${props => props.theme.defaultBorder};
    }
  }
`;

export const SignupStatImg = styled.img`
  height: 3.5rem;
`;

export const SignupStatH4 = styled.h4`
  text-transform: unset;
  font-weight: 400;
  text-align: center;
  height: 55px;
  margin-top: 1.2rem;
  max-width: 145px;
  @media screen and (min-width: 768px) {
    max-width: none;
    height: 45px;
    max-width: 185px;
  }
`;

export const SignupStatValueH2 = styled.h2`
  font-size: 2.3rem;
  color: ${props => props.theme[props.color]};
`;

export const SignupsBorderAside = styled.aside`
  height: 1px;
  width: 100%;
  background-color: ${props => props.theme.mercury};
  margin: 3rem 0;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;
